import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  useGetPatientLeadInformationQuery,
  useUpdatePatientLeadInformationMutation,
} from "app/store/transmission/api/transmissionTableApi";
import { showToast } from "utils/toast";
import { useDispatch } from "react-redux";
import { patientApi } from "app/store/patient/api/patientApi";

const useLeadInformation = () => {
  const [leads, setLeads] = useState();
  const [initialLeads, setInitialLeads] = useState([]);
  const [leadFormData, setLeadFormData] = useState([]);
  const dispatch = useDispatch();

  const { patientId } = useSelector((state) => state.transmission);

  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasIncompleteLeadInformation, setHasIncompleteLeadInformation] =
    useState(false);

  const {
    data,
    isLoading: isLeadInformationLoading,
    isFetching,
  } = useGetPatientLeadInformationQuery(
    { patientId },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    setLeads(data ?? []);
    setInitialLeads(data ?? []);
    setLeadFormData(data ?? []);
  }, [data]);

  const [updatePatientLeadInformation] =
    useUpdatePatientLeadInformationMutation();

  useEffect(() => {
    if (initialLeads && initialLeads.length) {
      checkHasIncompleteLeadInformation(initialLeads);
    }
  }, [initialLeads]);

  const checkHasIncompleteLeadInformation = (initialLeads) => {
    const propertiesToCheck = ["manufacturer", "serial_number"];

    const hasEmptyProperties = initialLeads.some((item) =>
      propertiesToCheck.some((prop) => !item[prop])
    );

    setHasIncompleteLeadInformation(hasEmptyProperties);
  };

  const handleSubmit = async (leads) => {
    try {
      setIsLoading(true);

      const filteredleads = leads
        .filter((lead) => lead.type !== "" && lead.manufacturer !== "")
        .map((lead) => ({
          ...lead,
          active: lead?.active ?? false,
          advisory: lead?.advisory ?? false,
        }));

      const response = await updatePatientLeadInformation({
        patientId,
        leads: filteredleads,
      });

      if (response?.error) throw new Error(response?.error?.message);

      if (!response.error) {
        setIsEditMode(false);
        showToast({ message: response?.data.message });

        setHasIncompleteLeadInformation(false);
        setInitialLeads([...filteredleads]);
        setLeadFormData([...filteredleads]);
        dispatch(patientApi.util.invalidateTags(["patientList"]));
      }
    } catch (error) {
      showToast({ message: error.message, type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = async () => {
    setLeadFormData(data);
    setIsEditMode(false);
  };

  const handleEdit = () => {
    if (leads?.length > 0) {
      const copy = [...leads];
      setLeadFormData(copy);
    }
    setIsEditMode(true);
  };

  return {
    isLoading,
    isFetching,
    isLeadInformationLoading,

    isEditMode,
    handleEdit,

    leadFormData,
    setLeadFormData,

    handleCancel,
    handleSubmit,

    leads,
    setInitialLeads,
    hasIncompleteLeadInformation,
  };
};

export default useLeadInformation;
